import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkActivityOptionDetailsComponent } from '../work-activity-option-details/work-activity-option-details.component';
import { WorkActivityOptionsModel } from '../work-activity-option.model';
import { WorkActivityOptionsService } from '../work-activity-options.service';

@Component({
  selector: 'app-work-activity-options-list',
  templateUrl: './work-activity-options-list.component.html',
  styleUrls: ['./work-activity-options-list.component.scss']
})
export class WorkActivityOptionsListComponent implements OnInit, OnDestroy {
  private _subject$: Subject<boolean> = new Subject();
  public workActivities :WorkActivityOptionsModel[] =[];
  public selectedWorkActivityOption : WorkActivityOptionsModel = null
  constructor(
    private dialogService: DialogService,
    private workActivityOptionService: WorkActivityOptionsService ) {  }

  ngOnInit() {
    this.getWorkActivityOptions();
  }

  openDetails() { 
    if(this.selectedWorkActivityOption != null)
    this.workActivityOptionService
          .getOneById(this.selectedWorkActivityOption.aoId)
          .pipe(takeUntil(this._subject$))
          .subscribe((data : any) => {
            this.selectedWorkActivityOption = data;
            this.openDialog(this.selectedWorkActivityOption);
            this.selectedWorkActivityOption = null;
          });     
  }

  onCellClick($event) {
    this.selectedWorkActivityOption = $event.dataItem
  } 

  openDialog(selectedWorkActivityOption){
    const dialogRef = this.dialogService.open({
      minWidth: "700px",
      content: WorkActivityOptionDetailsComponent,
    });
    dialogRef.content.instance.selectedWorkActivityOption = selectedWorkActivityOption;
    dialogRef.result.subscribe((r:any) => {
      if ((r instanceof DialogCloseResult)!= null) {
         this.getWorkActivityOptions();
      }
      this.selectedWorkActivityOption = null;
    });
  }

  getWorkActivityOptions(){
    this.workActivityOptionService
    .getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data:any) => {
      this.workActivities = data;
    });
  }

  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}
